var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLimitedLogo = function SvgLimitedLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 17
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#373a36",
    d: "M-47-1210h320v14600H-47z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-30 -88.5)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 285,
    height: 245,
    stroke: "#E6E6E6",
    rx: 8
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(25 85.5)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 143,
    height: 24,
    fill: "#373A36",
    rx: 12
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M14.17 4.36a7.14 7.14 0 1 1-.085 14.28H14a7.14 7.14 0 1 1 .085-14.28Zm-.085.856a6.284 6.284 0 0 0 .085 12.568h-.085A6.284 6.284 0 0 0 14 5.216ZM14 7.08a.51.51 0 0 1 .51.48l-.001 3.77h3.061a.51.51 0 0 1 .03 1.02H14l-.052-.005-.036-.003a.506.506 0 0 1-.421-.472l-.001-4.28a.51.51 0 0 1 .51-.51"
  }))))));
};
export default SvgLimitedLogo;